import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import { initAnalytics } from '@/core/analytics'
import { i18nReady } from '@/core/i18n'
import { initSentry } from '@/core/sentry'
import { setupSupport } from '@/features/support/setup-support'
import { RootErrorFallback } from '@/shared/components/error-fallback'
import { useIsDesktop } from '@/shared/hooks/use-is-desktop'
import App from './App'
import { QueryProvider } from './shared/providers/query-provider'
import { ThemeProvider } from './shared/providers/theme-provider'
import './index.css'

initSentry()
initAnalytics()
setupSupport()

const toastStyle = {
  background: 'var(--theme-toast-bg)',
  color: '#fff',
  border: 'none',
  borderRadius: '16px',
}

function AppToaster() {
  const isDesktop = useIsDesktop()
  return (
    <Toaster
      position={isDesktop ? 'bottom-center' : 'top-center'}
      offset={isDesktop ? undefined : { top: 56 }}
      toastOptions={{ style: toastStyle }}
    />
  )
}

i18nReady.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<RootErrorFallback />}>
        <ThemeProvider>
          <QueryProvider>
            <App />
            <AppToaster />
          </QueryProvider>
        </ThemeProvider>
      </Sentry.ErrorBoundary>
    </StrictMode>,
  )
})
